// Subtle notification tones via Web Audio API. Deliberately soft — never siren/dispatch-like.
let ctx = null;

export function ensureAudio() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

export function audioReady() {
  return !!ctx && ctx.state === "running";
}

function beep(context, freq, start, duration, volume) {
  const osc = context.createOscillator();
  const gain = context.createGain();
  osc.type = "sine";
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0, start);
  gain.gain.linearRampToValueAtTime(volume, start + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);
  osc.connect(gain).connect(context.destination);
  osc.start(start);
  osc.stop(start + duration + 0.02);
}

// Returns true if a tone was played, false if audio is blocked/unavailable.
export function playTone(severity, volume = 0.7) {
  const context = ensureAudio();
  if (!context || context.state !== "running") return false;
  const now = context.currentTime;
  const v = Math.max(0, Math.min(1, volume)) * 0.35;
  if (severity === "critical") {
    // two gentle rising tones
    beep(context, 620, now, 0.18, v);
    beep(context, 780, now + 0.22, 0.22, v);
  } else {
    // one soft tone
    beep(context, 660, now, 0.22, v);
  }
  return true;
}
